module.exports = "pegasus/assets/blocks/column-5-theme4.png";